import React from 'react';

export interface Tab<T extends string = string> {
  id: T;
  label: string;
  icon?: string;
}

export interface TabBarProps<T extends string = string> {
  tabs: ReadonlyArray<Tab<T>>;
  activeTab: T;
  onTabChange: (id: T) => void;
  className?: string;
}

export function TabBar<T extends string>({
  tabs,
  activeTab,
  onTabChange,
  className,
}: TabBarProps<T>): React.JSX.Element {
  return (
    <nav
      role="tablist"
      className={`tab-bar${className ? ` ${className}` : ''}`}
      aria-label="View tabs"
    >
      {tabs.map((tab) => (
        <button
          key={tab.id}
          role="tab"
          aria-selected={tab.id === activeTab}
          className={`tab-chip${tab.id === activeTab ? ' tab-chip--active' : ''}`}
          onClick={() => onTabChange(tab.id)}
        >
          {tab.icon && (
            <span className="material-symbols-rounded" aria-hidden="true">
              {tab.icon}
            </span>
          )}
          {tab.label}
        </button>
      ))}
    </nav>
  );
}
